module.exports = __webpack_public_path__ + "img/card_ip_stipulation86.876ce050.svg";